const Button = ({ children, className = '', ...props }) => (
  <button
    className={`bg-blue-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-blue-700 transition ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;